
    <!-- Dialog Overlay -->
    <div class="dialog-overlay" id="dialogOverlay">
        <div class="dialog" id="confirmationDialog">
            <!-- Dialog Header -->
            <div class="dialog-header">
                <h2 class="dialog-title" id="dialogTitle">{{ title }}</h2>
            </div>

            <!-- Dialog Content -->
            <div class="dialog-content">
                <!-- Warning/Info Icon -->
                <svg class="warning-icon" id="dialogIcon" viewBox="0 0 24 24">
                    <path d="M12,2L13.09,8.26L22,9L13.09,9.74L12,16L10.91,9.74L2,9L10.91,8.26L12,2Z" />
                </svg>

                <div class="dialog-message" id="dialogMessage">
                    {{ message }}
                </div>

                <!-- Dialog Actions -->
                <div class="dialog-actions">
                    <button class="button button-secondary" (click)="cancel()">Cancel</button>
                    <button class="button button-primary" (click)="confirm()">Yes, Continue</button>
                </div>
            </div>
        </div>
    </div>
